import request from './request';

export function getMyViolations(params) {
  return request.get('/api/violation/myViolations', { params });
}
